import React from "react";
import ChangeCategoryCard from "./ChangeCategoryCard";
import styles from "./diffChanges.module.scss";
const changeLine = (value) => (React.createElement("div", { key: value, className: styles["change-line"] }, value));
const UriChanges = ({ uris }) => {
    const added = uris
        .filter((change) => change.change !== "removed")
        .map((change) => changeLine(change.current));
    const removed = uris
        .filter((change) => change.change === "removed")
        .map((change) => changeLine(change.previous));
    return (React.createElement(ChangeCategoryCard, { title: "Network references", added: added, removed: removed }));
};
export default UriChanges;
//# sourceMappingURL=UriChanges.js.map